import { onboarding } from '@services';

export interface IPatchFileStatus {
  fileId: string;
  studioId: string;
  status: 'open' | 'closed';
}

const patchFileStatus = async ({
  fileId,
  studioId,
  status,
}: IPatchFileStatus): Promise<void> => {
  await onboarding.patch(
    `/api/v1/file/status?studioId=${studioId}&fileId=${fileId}&status=${status}`,
  );
};

export { patchFileStatus };
